import { replaceUnderscores } from "./replaceUnderscores";
import { Option, Sexes } from "./types";

export const genderOptions: Option[] = Sexes.map((sexValue) => ({
  value: sexValue,
  label: replaceUnderscores(sexValue),
}));
